import { SubHeading } from '../common/subHeading';
import SipCalculatorNew from '../sipCalculatorNew';

export const ReturnCalculator = ({ returns, returnsCategory }) => {
  return (
    <div className="lil-mt-5">
      <SubHeading title="Returns calculator" />
      <h2 className="lil-mt-8 lil-text-s-20 lil-font-medium">
        Investment Type
      </h2>
      <div className="lil-py-6 sm:lil-px-6">
        <SipCalculatorNew returns={returns} categoryDetails={returnsCategory} />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/returnCalculator.tsx